import { render, staticRenderFns } from "./boot_image.vue?vue&type=template&id=22b1a9bc&scoped=true"
import script from "./boot_image.vue?vue&type=script&lang=ts"
export * from "./boot_image.vue?vue&type=script&lang=ts"
import style0 from "./boot_image.vue?vue&type=style&index=0&id=22b1a9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b1a9bc",
  null
  
)

export default component.exports